// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__2n-H9","vLegacy":"SelectSecondary_vLegacy__3qyDv","error":"SelectSecondary_error__3y_QS","disabled":"SelectSecondary_disabled__w_NnA"};